import { render, staticRenderFns } from "./brarylist.vue?vue&type=template&id=4be66ae6&scoped=true"
import script from "./brarylist.vue?vue&type=script&lang=js"
export * from "./brarylist.vue?vue&type=script&lang=js"
import style0 from "./brarylist.vue?vue&type=style&index=0&id=4be66ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be66ae6",
  null
  
)

export default component.exports